(function () {
  'use strict';
  var configElement = document.getElementById('EliteBenefitScenes');
  if (!configElement || document.getElementById('EliteBenefitDialog')) return;
  var config = JSON.parse(configElement.textContent);
  var scenes = config.scenes || {
    titanium: [
      ['Ve más lejos cuando oscurece', 'Enfoca el haz de luz en el camino cuando la iluminación cercana no sea suficiente.'],
      ['Hecha para los golpes del día a día', 'Un cuerpo de metal resistente para los golpes del trabajo y el uso al aire libre.'],
      ['Luz para lo que estás haciendo', 'Usa la luz lateral para tareas de cerca o cambia de modo según la situación.'],
      ['Lista para ir más allá del patio', 'Mantén a la vista tu equipo y dónde pisas en las salidas de pesca y las noches al aire libre.'],
      ['Recárgala para la próxima salida', 'Conéctala por USB y ten tu linterna lista para el próximo viaje o corte de luz.']
    ],
    ironclad: [
      ['Un cuerpo de metal de tamaño completo', 'Once pulgadas de aluminio mecanizado con un agarre texturizado que se siente sólido en la mano.'],
      ['Alcanza más lejos en tu propiedad', 'Enfoca el haz de luz para revisar la cerca y ver más lejos en el patio.'],
      ['Ilumina la oscuridad', 'Usa un haz de luz amplio para ver más del espacio que te rodea.'],
      ['Cuatro baterías extraíbles', 'Reemplaza las baterías compatibles y ten un juego cargado listo para tu próxima salida.'],
      ['Energía de respaldo para tu teléfono', 'Conecta tu teléfono a la salida USB cuando no tengas un enchufe a mano.']
    ]
  }[config.model];
  if (!scenes) return;
  var dialog = document.createElement('dialog');
  dialog.id = 'EliteBenefitDialog';
  dialog.className = 'elite-benefit-dialog';
  dialog.setAttribute('aria-labelledby', 'EliteBenefitTitle');
  dialog.setAttribute('aria-describedby', 'EliteBenefitCaption');
  dialog.innerHTML = '<div class="elite-benefit-head"><div><p class="elite-benefit-product"></p><h2 id="EliteBenefitTitle"></h2></div><button type="button" class="elite-benefit-close" aria-label="Cerrar vista previa del beneficio"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></button></div><figure class="elite-benefit-figure"><div class="elite-benefit-image-wrap"><p class="elite-benefit-status" role="status">Cargando foto…</p><img class="elite-benefit-photo" width="1200" height="800" decoding="async" hidden></div><figcaption id="EliteBenefitCaption" class="elite-benefit-caption"></figcaption></figure>';
  dialog.querySelector('.elite-benefit-product').textContent = config.product;
  document.body.appendChild(dialog);
  var photo = dialog.querySelector('img');
  var status = dialog.querySelector('.elite-benefit-status');
  var trigger, previousOverflow, backdropDown = false;
  photo.addEventListener('load', function () { photo.hidden = false; status.hidden = true; });
  photo.addEventListener('error', function () { photo.hidden = true; status.textContent = 'No se pudo cargar la foto. Cierra y vuelve a intentarlo.'; status.hidden = false; });
  function open(index, button) {
    if (dialog.open) return;
    trigger = button;
    var scene = scenes[index];
    dialog.querySelector('h2').textContent = scene[0];
    dialog.querySelector('figcaption').textContent = String(scene[1] || '').replace(/^Illustrative scene based on the selected (?:model|product reference)\.\s*/i, '');
    photo.alt = config.product + ' — ' + scene[0].toLowerCase();
    photo.hidden = true;
    status.textContent = 'Cargando foto…';
    status.hidden = false;
    photo.src = config.images[index];
    if (photo.complete && photo.naturalWidth) { photo.hidden = false; status.hidden = true; }
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('button').focus({ preventScroll: true });
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.querySelector('button').addEventListener('click', close);
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
  dialog.addEventListener('close', function () {
    document.body.style.overflow = previousOverflow;
    if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
  });
  dialog.addEventListener('pointerdown', function (event) {
    var r = dialog.getBoundingClientRect();
    backdropDown = event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom);
  });
  dialog.addEventListener('click', function (event) { if (event.target === dialog && backdropDown) close(); backdropDown = false; });
  function enhance() {
    document.querySelectorAll('.elite-product-info #badges-product').forEach(function (list) {
      if (list.dataset.benefitsReady) return;
      list.dataset.benefitsReady = 'true';
      var hint = document.createElement('p');
      hint.className = 'elite-benefit-hint';
      hint.textContent = 'Toca un beneficio para verlo en uso.';
      list.before(hint);
      list.querySelectorAll('.badge').forEach(function (badge, index) {
        if (!scenes[index]) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = badge.className + ' elite-benefit-trigger';
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', dialog.id);
        button.setAttribute('data-benefit-index', index);
        while (badge.firstChild) button.appendChild(badge.firstChild);
        var icon = button.querySelector('svg');
        if (icon) icon.setAttribute('aria-hidden', 'true');
        var affordance = document.createElement('span');
        affordance.className = 'elite-benefit-open';
        affordance.setAttribute('aria-hidden', 'true');
        affordance.textContent = '+';
        button.appendChild(affordance);
        button.addEventListener('click', function () { open(index, button); });
        badge.replaceWith(button);
      });
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', enhance);
})();

